import { Box } from "@mui/material";
import theme from "assets/theme";
import React from "react";

const CBBulletPoint = ({ small, med, ...props }) => {
  return (
    <Box
      role="img"
      aria-label="bullet point"
      sx={{
        height: small ? "8px !important" : med ? "12px" : "16px",
        width: small ? "8px !important" : med ? "12px" : "16px",
        backgroundColor: theme.palette.secondary.main,
        marginRight: ".5rem",
        borderRadius: "50%",
        ...props.sx,
      }}
    ></Box>
  );
};

export default CBBulletPoint;
